import { isArray } from 'lodash'

export const convertToImpressionData = (item: Record<string, any> | Record<string, any>[]) => {
  if (isArray(item)) return item.map(i => ({ id: i.id, name: i.title }))
  else return { id: item.id, name: item.title }
}

export const convertToProductData = (item: Record<string, any>) => {
  return { id: item.id, name: item.title, price: item.price }
}

export const convertToPurchaseData = (item: Record<string, any>) => {
  return { id: item.id, name: item.title, price: item.price, quantity: 1 }
}

export const convertToEcommerceItem = (item: Record<string, any> | Record<string, any>[]) => {
  if (isArray(item))
    return item.map(i => ({
      item_id: i.id,
      item_name: i.title,
      price: i.price,
      quantity: 1,
    }))
  else
    return {
      item_id: item.id,
      item_name: item.title,
      price: item.price,
      quantity: 1,
    }
}
